import React, { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { X, Loader2, Star } from "lucide-react";
import ImageUpload from "./ImageUpload";

const EMPTY = { name: "", location: "", rating: 5, text: "", image: "", trip: "", active: true };

export default function TestimonialFormModal({ initial, onClose, onSaved }) {
  const [f, setF] = useState(initial ? { ...EMPTY, ...initial } : EMPTY);
  const [loading, setLoading] = useState(false);

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    setF({ ...f, [name]: type === "checkbox" ? checked : value });
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!f.name || !f.text) { toast.error("Name and testimonial text are required"); return; }
    setLoading(true);
    const payload = { ...f, rating: Number(f.rating) || 5 };
    try {
      if (initial) await api.patch(`/admin/testimonials/${initial.id}`, payload);
      else await api.post("/admin/testimonials", payload);
      toast.success(initial ? "Testimonial updated" : "Testimonial added");
      onSaved(); onClose();
    } catch { toast.error("Save failed"); }
    finally { setLoading(false); }
  };

  const input = "w-full px-4 py-2.5 rounded-xl border border-slate-200 text-sm focus:outline-none focus:border-[#006CE4] focus:ring-4 focus:ring-blue-100 transition";
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" data-testid="testimonial-form-modal">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-xl max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between p-6 border-b border-slate-100">
          <h3 className="h3">{initial ? "Edit Testimonial" : "Add Testimonial"}</h3>
          <button onClick={onClose} className="p-2 hover:bg-slate-100 rounded-full"><X className="w-5 h-5" /></button>
        </div>
        <form onSubmit={submit} className="p-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div><label className="text-xs font-semibold muted">Customer Name *</label><input required name="name" value={f.name} onChange={onChange} className={input} data-testid="testimonial-form-name" /></div>
          <div><label className="text-xs font-semibold muted">Location</label><input name="location" value={f.location} onChange={onChange} className={input} placeholder="Mumbai" data-testid="testimonial-form-location" /></div>
          <div><label className="text-xs font-semibold muted">Trip Taken</label><input name="trip" value={f.trip} onChange={onChange} className={input} placeholder="Maldives Honeymoon" data-testid="testimonial-form-trip" /></div>
          <div><label className="text-xs font-semibold muted">Rating (1–5)</label>
            <div className="flex items-center gap-1 mt-2">
              {[1,2,3,4,5].map((r) => (
                <button type="button" key={r} onClick={() => setF({ ...f, rating: r })} className="p-1" data-testid={`testimonial-form-star-${r}`}>
                  <Star className={`w-5 h-5 ${r <= f.rating ? "fill-[#FF7D00] text-[#FF7D00]" : "text-slate-300"}`} />
                </button>
              ))}
            </div>
          </div>
          <div className="sm:col-span-2"><label className="text-xs font-semibold muted">Testimonial Text *</label><textarea required name="text" value={f.text} onChange={onChange} rows="4" className={`${input} resize-none`} data-testid="testimonial-form-text" /></div>
          <div className="sm:col-span-2">
            <label className="text-xs font-semibold muted">Avatar Image</label>
            <ImageUpload value={f.image} onChange={(url) => setF({ ...f, image: url })} testId="testimonial-form-image" />
          </div>
          <label className="sm:col-span-2 flex items-center gap-2 text-sm"><input type="checkbox" name="active" checked={!!f.active} onChange={onChange} className="accent-[#FF7D00]" data-testid="testimonial-form-active" /> Active (shows on homepage)</label>
          <div className="sm:col-span-2 flex gap-3 pt-2">
            <button type="button" onClick={onClose} className="btn-outline flex-1 justify-center">Cancel</button>
            <button type="submit" disabled={loading} className="btn-primary flex-1 justify-center disabled:opacity-60" data-testid="testimonial-form-submit">{loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Save"}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
